import './base-service.js';
import './activity-service.js';
import './activity-draft-service.js';
import './activity-template-service.js';
import './activity-type-catalog-service.js';
import './app-license-service.js';
import './app-settings-service.js';
import './client-service.js';
import './clientGroup-service.js';
import './clients-and-prospects-service.js';
import './employee-position-service.js';
import './employee-service.js';
import './estimated-hours-service.js';
import './google-api-service.js';
import './google-calendar-events-service.js';
import './import-pending-list-service.js';
import './google-token-persistance-service.js';
import './holydays-service.js';
import './invoice-service.js';
import './scope-change-request-service.js';
import './scope-change-review-service.js';
import './pager-service.js';
import './product-service.js';
import './project-actions.js';
import './project-service.js';
import './project_type-service.js';
import './prospect-service.js';
import './quotation-service.js';
import './session-service.js';
import './session-storage.js';
import './user-service.js';
import './workspace-service.js';
import './notification-service.js';
import './assignment-service.js';

export default 'thothApp.services';
